/*
 * Copyright (c) 2023-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import DisplayIcon from "./Icons/DisplayIcon.jsx";
import Proximity from "./Proximity.jsx";

class DropdownExpand extends Component {
    render() {
        let {defaultWidth, defaultHeight, width, height, onChange} = this.props

        let isExpanded = (width !== defaultWidth || height !== defaultHeight)
        return (
            <>
                {/*Expand to the left*/}
                <Proximity proximityX={20} proximityY={20} className={"absolute bottom-0 left-0 w-6 h-6"}>
                    {isInProximity => {
                        return <div
                            className={`absolute bottom-0 left-0 w-6 h-6 hover:bg-white flex items-center justify-center cursor-pointer bg-white/30 hover:shadow rounded opacity-0 z-10  transition-all duration-300 ${isInProximity && "!opacity-100"}`}
                            onClick={() => {
                                if (onChange !== undefined) {
                                    if (isExpanded) {
                                        onChange(defaultWidth, defaultHeight)
                                    } else {
                                        onChange(1294, 800)
                                    }
                                }
                            }}
                        >
                            <DisplayIcon iconName={"IoChevronBack"}
                                         className={`${(isExpanded) ? ("rotate-90") : ("-rotate-45")} `}/>
                        </div>

                    }}
                </Proximity>

                {/*Expand to the right*/}
                <Proximity proximityX={20} proximityY={20} className={"absolute bottom-0 right-0 w-6 h-6"}>
                    {isInProximity => {
                        return <div
                            className={`absolute bottom-0 right-0 w-6 h-6 hover:bg-white flex items-center justify-center cursor-pointer bg-white/30 hover:shadow rounded opacity-0 z-10  transition-all duration-300 ${isInProximity && "!opacity-100"}`}
                            onClick={() => {
                                if (onChange !== undefined) {
                                    if (isExpanded) {
                                        onChange(defaultWidth, defaultHeight)
                                    } else {
                                        onChange(1294, 800)
                                    }
                                }
                            }}
                        >
                            <DisplayIcon iconName={"IoChevronForward"}
                                         className={`${(isExpanded) ? ("-rotate-90") : ("rotate-45")} `}/>
                        </div>

                    }}
                </Proximity>

            </>
        );
    }
}

DropdownExpand.propTypes = {
    defaultWidth: PropTypes.any,
    defaultHeight: PropTypes.any,
    width: PropTypes.any,
    height: PropTypes.any,
    onChange: PropTypes.func,
};

export default DropdownExpand;